import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-notifications",
  "use": "icon-menu-notifications-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-notifications\">\n<path d=\"M10.5 14.2972C10.5 15.1759 9.82008 15.8957 8.95768 15.9593L8.83329 15.9639H7.16662C6.28799 15.9639 5.56815 15.284 5.50453 14.4216L5.49996 14.2972H10.5ZM8.00012 0.130554C11.1547 0.130554 13.7244 2.63454 13.8301 5.76335L13.8335 5.96389V9.10047L15.3518 12.1373C15.642 12.7178 15.2539 13.3958 14.6276 13.4591L14.532 13.4639H1.46827C0.819282 13.4639 0.386375 12.8135 0.609872 12.225L0.648374 12.1373L2.16676 9.10047V5.96389C2.16676 2.74223 4.77843 0.130554 8.00012 0.130554Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/menu-notifications.svg
// module id = /YsF
// module chunks = 258